import { IPhase, PhaseModel, PhaseType } from '../types';
import { MapPhaseModel, ProposalPhaseModel, SitePlanPhaseModel } from '../models';

export const createPhaseModel = (phase: IPhase): PhaseModel => {
  switch (phase.type) {
    case PhaseType.MAP:
      return new MapPhaseModel(phase);
    case PhaseType.SITE_PLAN:
      return new SitePlanPhaseModel(phase);
    case PhaseType.PROPOSAL:
      return new ProposalPhaseModel(phase);
    default:
      return new MapPhaseModel({ ...phase, type: PhaseType.MAP });
  }
};

export const phaseTypeToPath = (phaseType: PhaseType): string => {
  switch (phaseType) {
    case PhaseType.MAP:
      return 'map';
    case PhaseType.SITE_PLAN:
      return 'site-plan';
    case PhaseType.PROPOSAL:
      return 'proposal';
    default:
      return 'map';
  }
};

export const phasePathToType = (segment: string): PhaseType | null => {
  switch (segment) {
    case 'map':
      return PhaseType.MAP;
    case 'site-plan':
    case 'siteplan':
      return PhaseType.SITE_PLAN;
    case 'proposal':
      return PhaseType.PROPOSAL;
    default:
      return null;
  }
};

export const getPhaseStatusColor = (phase: IPhase, token: Record<string, any>): string => {
  if (phase.status === 'completed') return token.colorSuccess;
  if (phase.isActive || phase.status === 'active') return token.colorPrimary;
  return token.colorTextDisabled;
};

export const getPhaseStatusText = (phase: IPhase): string => {
  if (phase.status === 'completed') return 'Completed';
  if (phase.isActive || phase.status === 'active') return 'In Progress';
  return 'Upcoming';
};
